import "./MoneyCreditManagementPageAdmin.css";

import React, { useState } from "react";
import moneyBack from "Media/icons/moneyBack.png";
import creditHistory from "Media/icons/credit-history.png";
import tradeIcon from "Media/icons/trade@2x.png";

import Headers from "Components/Header/Headers";
import Navigation from "Components/SideNavBar/Navigation";
import RenderInformationPopup from "Components/Popup/InformationPopup/PureComponents/InformationPopup";
import dollarIcon from "Media/icons/cards-with-dollar-sign@2x.png";
import moneyIcon from "Media/icons/money@2x.png";
import renewIcon from "Media/icons/renew@2x.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { toast } from "react-toastify";
const MoneyCreditManagementPageAdmin = () => {
  const navigate = useNavigate();
  const credit = useSelector((state) => state.getStripeCreditBalanceReducer);
  const [infoPopup, setInfoPopup] = useState(false);
  const [tabsText, setTabsText] = useState("");
  const loggedInUserDetails = useSelector(
    (state) => state.authenticationReducer,
  );
  return (
    <>
      <div className="mc-management-admin-main">
        <div className="mc-management-admin-header">
          <Headers />
        </div>

        <div className="mc-management-admin-navigation">
          <Navigation />
        </div>

        <div className="mc-management-admin-wrapper">
          <div className="mc-management-admin-heading">
            Money Management Page
          </div>
          <div
            style={{ position: "relative" }}
            className="mc-management-content"
          >
            <div
              className="mc-management-tile"
              style={{ height: "110px" }}
              onClick={() => navigate("/all-credit-history")}
            >
              <img
                src={creditHistory}
                alt="Wallet"
                style={{ width: "65px", height: "65px" }}
              />
              <span>All Organization Balance</span>
              <QuestionMarkIcon
                className="moneyCreditManagement-info"
                onClick={() => {
                  setInfoPopup(true);
                  setTabsText("All Organization Balance");
                }}
              />
            </div>
            <div className="mc-management-tile" style={{ height: "110px" }}>
              <img
                src={dollarIcon}
                alt="Wallet"
                style={{ width: "65px", height: "65px" }}
              />
              <span>
                <span>Stripe Wallet Available Balance</span>
                <span>
                  <b> {credit ? credit : 0}</b>
                </span>
              </span>
              <QuestionMarkIcon
                className="moneyCreditManagement-info"
                onClick={() => {
                  setInfoPopup(true);
                  setTabsText("Stripe Wallet Available Balance");
                }}
              />
            </div>
            <div
              className="mc-management-tile"
              style={{ height: "110px" }}
              onClick={() => {
                if (loggedInUserDetails?.credit_read_rights === "manager")
                  return navigate("/all-refund-requests");
                toast("You do not have rights to view refund requests", {
                  type: "info",
                });
              }}
            >
              <img
                src={moneyBack}
                alt="Wallet"
                style={{ width: "65px", height: "65px" }}
              />

              <span> All Refund Requests </span>
              <QuestionMarkIcon
                className="moneyCreditManagement-info"
                onClick={() => {
                  setInfoPopup(true);
                  setTabsText("Refund Requests");
                }}
              />
            </div>
            <div
              className="mc-management-tile"
              style={{ height: "110px" }}
              onClick={() => navigate("/rates-and-subscription-management")}
            >
              <img
                src={renewIcon}
                alt="Wallet"
                style={{ width: "65px", height: "65px" }}
              />
              <span>Rates & Subscription</span>
              <QuestionMarkIcon
                className="moneyCreditManagement-info"
                onClick={() => {
                  setInfoPopup(true);
                  setTabsText("Rates & Subscription");
                }}
              />
            </div>
              <div
            className="mc-management-tile"
            style={{ height: "110px" }}
            onClick={() => {
              if (loggedInUserDetails?.credit_read_rights === "manager")
                return navigate("/money-credit-transaction-activity");
              toast("You do not have rights to view transaction activities", {
                type: "info",
              });
            }}
          >
            <img
              src={tradeIcon}
              alt="Wallet"
              style={{ width: "65px", height: "65px" }}
            />
            <span>Transaction Activity</span>
            <QuestionMarkIcon
              className="moneyCreditManagement-info"
              onClick={() => {
                setInfoPopup(true);
                setTabsText("Transaction Activity");
              }}
            />
          </div>
          </div>
        
        </div>
      </div>
      {infoPopup && (
        <RenderInformationPopup message={tabsText} hide={setInfoPopup} />
      )}
    </>
  );
};

export default MoneyCreditManagementPageAdmin;
